import { baseURL } from './http.js';
import request from './request.js';

export default {
  // 寻样申请查询
  // 包材
  getPackingMaterialListPage: item => request(baseURL).post('sample/packingMaterialListPage', item),
  // ODM
  getODMListPage: item => request(baseURL).post('sample/odmListPage', item),
  getById: val => request(baseURL).get(`sample/get?id=${val}`),
  getBySpecificationId: val => request(baseURL).get(`sample/getBySpecificationId?${val}`),
  // 膜布
  getFabricListPage: item => request(baseURL).post('sample/fabricListPage', item),
  // 原料
  getRawMaterialListPage: item => request(baseURL).post('sample/rawMaterialListPage', item),
  // 加入购物车
  batchCreateToShoppingCart: item => request(baseURL).post('shoppingCart/batchCreate', item),
};